import { BaseRequest } from "../../../../base/request/BaseRequest";

/** Request de validación de sesión por token (revalida el token guardado al
 *  arrancar la app). */
export type LoginByTokenRequest = BaseRequest & {
  /** Token de sesión. */
  token: string;
};

export const fx_createLoginByTokenRequest = (
  token: string,
): LoginByTokenRequest => {
  return {
    token: token,
  };
};
